import React from 'react';
import { VStack, Text } from '@chakra-ui/react';
import HeroSection from '../components/common/HeroSection';
import Content from '../components/participate/Content';
import MiniNavbar  from '../components/common/MiniNavbar'; 
const AboutUs = () => {
    return (
        <VStack spacing={0}>
            <HeroSection />
            <MiniNavbar /> 
            <Content/>
        </VStack>
    );
};

export default AboutUs;
